// extracted by mini-css-extract-plugin
export var container = "_4q-0";
export var infoButton = "_4q-1";
export var label = "_4q-3";
export var labelExpanded = "_4q-4";
export var price = "_4q-5";
export var priceExpanded = "_4q-6";
export var title = "_4q-2";